import { DataModel } from "common/models/utility-models/base-model";

export class EmailTemplateModel extends DataModel {
    name:any = '';
    subject:any='';
    body: string = '';
    keyword: string='';


}